export default function (actions, initialState) {
  return function(state = initialState, action) {
    const handler = actions[action.type];
    return handler ? handler(state, action) : state;
  };
}



// WEBPACK FOOTER //
// ./src/core/makeReducer.js